module.exports = __webpack_public_path__ + "img/1.a24e4b01.png";